import { useMemo, useState } from 'react';
import { StanDropdownMenu } from '@/components/core-components/StanDropdown/Menu/StanDropdownMenu';
import { DropdownProvider } from '@/components/core-components/StanDropdown/DropdownProvider';
import type { DropdownMenuOption, DropdownValue } from '@/components/core-components/StanDropdown/StanDropdown.types';
import DownloadIcon from '@/assets/icons/ic-download.svg';
import EmailIcon from '@/assets/icons/ic-email-flows.svg';
import { FiMoreVertical } from 'react-icons/fi';

interface RecipientActionsMenuProps {
    onExportCSV: () => void;
    onSendOptInEmails: () => void;
}

/**
 * Actions menu for recipients tab
 * Provides dropdown menu with export and opt-in email actions
 */
export const RecipientActionsMenu = ({ onExportCSV, onSendOptInEmails }: RecipientActionsMenuProps) => {
    const [selectedValue, setSelectedValue] = useState<DropdownValue | null>(null);

    const menuOptions: DropdownMenuOption[] = useMemo(() => {
        return [
            {
                label: 'Send all opt-in emails',
                value: 'send-opt-in',
                icon: EmailIcon,
            },
            {
                label: 'Download CSV',
                value: 'export-csv',
                icon: DownloadIcon,
            },
        ];
    }, []);

    const handleSelect = (value: DropdownValue) => {
        setSelectedValue(value);

        if (value.value === 'export-csv') {
            onExportCSV();
        } else if (value.value === 'send-opt-in') {
            onSendOptInEmails();
        }

        // Reset selection after action
        setTimeout(() => setSelectedValue(null), 100);
    };

    return (
        <DropdownProvider
            initialValue={selectedValue}
            dropdownId='recipient-actions-menu'
            dropdownName='recipientActions'
        >
            <StanDropdownMenu
                id='recipient-actions-menu'
                name='recipientActions'
                options={menuOptions}
                currentValue={selectedValue}
                onSelect={handleSelect}
                placement='bottom-end'
                rounded
            >
                <FiMoreVertical className='text-gray hover:text-dark size-5 cursor-pointer transition-colors' />
            </StanDropdownMenu>
        </DropdownProvider>
    );
};
